import React, { useState } from 'react';

import placeholder from '../../../assets/img-placeholder.jpg';

import './Gallery.css';

const Gallery = ({title, data=[]}) => {
    const [isLoaded, setIsLoaded] = useState(false);
   
    const deviceString = window.innerWidth>=481 ? 'Hover' : 'Tap' ;
    return (
        <div className="gallery container-fluid">
            <p className="gallery-title">{title}</p>
            <p className="gallery-subline">{deviceString} on the image to view caption</p>
            <div className="gallery-row">
                {
                   data.map(({id, image}) => (
                    <React.Fragment>
                        <div className="gallery-img-div" onLoad={() => setIsLoaded(true)} key={id}>
                                {
                                    isLoaded ? (
                                    
                                        <React.Fragment>
                                            <img className="gallery-img"
                                            src={image.image}
                                            alt=""
                                             />
                                            <div className="gallery-img-overlay ">
                                                <p className="gallery-img-overlay-caption">{image.caption}</p>
                                            </div>
                                        </React.Fragment>

                                    ) : (
                                        <img className={`gallery-placeholder`} src={placeholder} alt="" />
                                    )
                                }
                        </div>
                    </React.Fragment>
                    ))
                }
            </div>
        </div>
    );
};

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/imageAndGraphics/gallery/Gallery.js